module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-case"
  }, [_c('img', {
    staticClass: "top-img",
    attrs: {
      "src": require("assets/case/07/img1.png")
    }
  }), _vm._m(0), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.scrollTop),
      expression: "scrollTop"
    }],
    staticClass: "scroll-top-btn",
    attrs: {
      "src": require("assets/goTop.png")
    },
    on: {
      "click": _vm.backtop
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "case-num"
  }, [_vm._v("Vol.07")]), _c('div', {
    staticClass: "case-title"
  }, [_vm._v("65㎡精致小户型，处女座男生的神仙日子")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("每个细节精心设计、专门的娱乐室、融入潮流元素，这简直是年轻人的梦想屋啊")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("窝仔今天拜访的客户，是一名处女座男生。一起看看他精心打造的65㎡精致小屋吧。")]), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("关于屋主")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("屋主华先生追求精致生活，在房子的装修中，融入了很多自己的心思。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("华先生与心爱的人相识3年，两人有很多共同爱好，也很有默契。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("虽然现在是独自居住，但他计划这套房子以后用作婚房，所以在装修中也加入很多对未来生活的期待。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/07/img2.jpg")
    }
  }), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("「房子的基本信息」")]), _c('div', {
    staticClass: "line1"
  }, [_c('span', [_vm._v("坐标：上海静安")]), _vm._v(" "), _c('span', [_vm._v("面积：65㎡")]), _vm._v(" "), _c('span', [_vm._v("户型：两室一厅")])]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/07/img3.jpg")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("虽然屋主年初时才搬进来，但整洁程度还是超出了我们的预计。处女座的“天生优势”被发挥得淋漓尽致。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("不仅如此，精心搭配的装饰花卉，加之屋主心爱的玄凤鹦鹉，给我们呈上了一场“鸟语花香”的视听享受。")]), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("玄关&客厅"), _c('br'), _vm._v("三大巧思，给小户型加分")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("还没进屋，就发现了主人的小心思。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("大门上，主人亲手粘贴了毛毡。“Home is where we are”，给人回到家的温馨感。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/07/img4.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("进入大门，第一个空间是客餐厅。")]), _c('div', {
    staticClass: "line2"
  }, [_vm._v("巧思1：精心搭配，展示精致生活")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("客厅面积不大，家具摆放比较紧凑，没有多余的物件。给人的整体感觉，是精致、轻奢。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/07/img5.jpg")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("硬装色调定调之后，软装其实无需过分复杂，只要家具挑选得当，就轻松搭配出了精致轻奢风。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/07/img6.jpg")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("深蓝色的伊丽莎白沙发，颜色沉静，坐感柔软，一进屋就可以立刻坐下放松。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/07/img7.jpg")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("粉色、灰色的安普天鹅绒抱枕，跟深蓝形成对比，把优雅气质提到最佳。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/07/img8.jpg")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("沙发的丝绒材质，配上手感顺滑的桑德罗羊皮毯，让原本简洁的客厅，更有了一丝低调的奢华质感。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/07/img9.jpg")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("在木地板上铺一张圆形的莫西兔毛地毯，中和了木地板的硬朗，把温馨感衬托到极致。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/07/img10.jpg")
    }
  }), _c('div', {
    staticClass: "line2"
  }, [_vm._v("巧思2：墙面做柜体，增加收纳空间")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("很多人会担心，小户型没有足够的收纳空间，设计师给了很好的解决方案。"), _c('br'), _vm._v(" 把客厅墙面打造成柜体，增加了不少的收纳空间。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/07/img11.jpg")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("白色柜门与白色墙面融为一体。厨房的门，也在其中。"), _c('br'), _vm._v(" 把凌乱和油烟，都藏了起来。做饭的油烟和吵闹，也不会打扰到公共区域。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/07/img12.jpg")
    }
  }), _c('div', {
    staticClass: "line2"
  }, [_vm._v("巧思3：餐桌靠窗设计，不占地又实用")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("紧邻主沙发的，是一张嵌入式餐桌，与墙面收纳柜连成一体。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/07/img13.jpg")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("挨着窗户，在这里吃饭、喝茶时，还可以欣赏到窗外的景色。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/07/img14.jpg")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("搭配两张懂窝餐椅，绒面材质和金属椅腿，轻巧不繁杂，轻奢的质感与沙发区域相映成趣。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/07/img15.jpg")
    }
  }), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("娱乐室 "), _c('br'), _vm._v("次卧改成娱乐室，使用率翻倍")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("房子的重头戏之一，就是华先生专门打造的娱乐室。"), _c('br'), _vm._v(" 这个房间本来是次卧，改成娱乐室，使用率更高，也弥补了客餐厅有限的功能。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/07/img16.jpg")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("娱乐室里，靠墙摆放了一台钢琴。因为两人都爱好钢琴，华先生为此专门购入。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/07/img17.jpg")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("聊得兴起，他现场为我们弹奏了几首曲子，屋里立刻充满了艺术气息。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/07/img18.jpg")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("除了钢琴，还计划在这间房配一台投影仪，在家也能随时欣赏精彩大片。"), _c('br'), _vm._v(" 一张舒服的沙发，是看电影的必备。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("米白色的巴罗羽绒填充沙发，与深粉色墙面搭配，安静沉稳。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/07/img19.jpg")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("一张小茶几，方便放零食、茶水。跟客厅一样的圆形兔毛地毯，让房间更加温暖，就算冬天光脚也不觉得冷，观影的同时更加放松。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/07/img20.jpg")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("灰色系棉麻质地的冬丽抱枕，跟浅色沙发刚好搭配，也与地毯的颜色呼应。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/07/img21.jpg")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("角落的欧文黄铜地灯，光线柔和温馨，把娱乐室烘托得更加惬意。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/07/img22.jpg")
    }
  }), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("卧室"), _c('br'), _vm._v(" 沉静不失浪漫，还有“金屋藏娇”")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("卧室的配色跟娱乐室截然不同，沉静的蓝色墙面，一走进来，人就自然放松了。"), _c('br'), _vm._v(" 灰色的娜塔莎丝绒双人床，搭配蓝色的墙面，显得和谐优雅。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/07/img23.jpg")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("床上艾塔四件套也经过了精心挑选，灰蓝双面配色，高密贡缎质地。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/07/img24.jpg")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("华先生还特意在床头摆了鲜花，生活精致程度可见一斑。闻着花香，睡在这舒服的大床上，梦也更甜美了。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/07/img25.jpg")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("房间一角的海尔格羽毛落地灯，光线轻柔，把卧室的氛围营造得更浪漫。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/07/img26.jpg")
    }
  }), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/07/img27.jpg")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("“躲”在房间阳台的，是华先生心爱的宠物“秋秋”（音），一只漂亮的玄凤鹦鹉。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/07/img28.jpg")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("它居住的鸟笼跟主人的家一样精致，娱乐、饮食设施一应俱全，堪称鸟笼“豪宅”。")]), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("厨房&卫生间"), _c('br'), _vm._v(" 简洁实用，同时紧跟潮流")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("厨房和卫生间则以白色为主色调，让小空间不显拥挤。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/07/img29.jpg")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("卫生间采用了时下流行的谷仓门设计，别出心裁，同时也更节省空间。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/07/img30.jpg")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("镜子也紧跟科技，圆形镜面围绕触控灯带，洗漱、化妆时照得一清二楚。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/07/img31.jpg")
    }
  }), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("装修巧思")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("•  房子的功能可以因人而异，比如把次卧改成娱乐室")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("•  定好了硬装，软装无需复杂，几件家具就能搭出精致感")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("•  墙面改柜体，增加收纳空间，采用白色柜门，与墙面融为一体")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("•  卫生间采用谷仓门设计，既新潮又节省空间")]), _c('div', {
    staticClass: "cont-title1"
  }, [_vm._v(" Q&A")]), _c('div', {
    staticClass: "line2"
  }, [_c('span', [_vm._v("Q：为什么会选择懂窝的家具呢？")]), _vm._v("挑选家具时，设计师推荐了我另一家。但是那家的色调太深沉了。后来我发现了懂窝，设计更丰富，性价比也高，所以就在懂窝买了。")]), _c('div', {
    staticClass: "line2"
  }, [_c('span', [_vm._v("Q：在软装搭配方面有什么心得？")]), _vm._v("懂窝的软装搭配师有帮我推荐。然后我根据家里的装修基调，加上自己的喜好，挑选了几款家具，碰巧挑了两款懂窝的热卖沙发。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-503c2d71"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/case7.vue
// module id = 447
// module chunks = 0